import { PropsWithChildren } from 'react'

export type PanelProps = PropsWithChildren<
  Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> & {
    title?: React.ReactNode
    htmlTitle?: React.HTMLAttributes<HTMLDivElement>['title']
    noPadding?: boolean
    hasError?: boolean
  }
>

export function Panel({
  children,
  title,
  htmlTitle,
  noPadding,
  hasError,
  ...props
}: PanelProps) {
  return (
    <div
      title={htmlTitle}
      className={`overflow-hidden ${title ? 'rounded-xl' : 'md:rounded-xl'} border text-mydra-black ${props.className ?? ''}`}
    >
      {title && (
        <header className="border-b bg-grey-background p-4 font-semibold leading-7 md:px-6 md:py-4">
          {title}
        </header>
      )}
      <div
        className={`Panel-content ${
          !noPadding ? (title ? 'p-4 md:px-5 md:py-4' : 'px-4 py-6 md:p-5') : ''
        } ${hasError ? 'bg-[#FEF5F6]' : 'bg-white'}`}
      >
        {children}
      </div>
    </div>
  )
}
